import { Component, Input, OnInit } from '@angular/core';
import * as Models from '../../../models/models-index';
import { HelpTextService } from '../../../services/help/helpText.service';
import { ElementBaseComponent } from '../ElementBaseComponent';
import { of } from 'rxjs';

type MetricOutput = { "label": string, "value": string | number | Date, "trend": number, "subtitleOneValue": string | number | Date, "subtitleOneLabel" };

@Component({
    selector: 'tri-metric',
    templateUrl: './tri-metric.component.html',
    styleUrls: ['./tri-metric.component.scss'],
    standalone: false
})
export class TriMetricComponent extends ElementBaseComponent implements OnInit {
  @Input() set dataSets(value: Models.DataSet[]) {
    if (!!value && value.length > 0) {
      this.processData(value[0]);
      this.isDataSetLoaded$.next(true);
    } else {
      this.isDataSetLoaded$.next(false);
    }
  }

  @Input() settings: Models.ElementSettings;
  @Input() locale: string;

  title;
  titleIconClasses;

  metrics: MetricOutput[] = [];

  constructor(helpTextService: HelpTextService) {
    super(helpTextService);
  }

  ngOnInit() {
  }

  processData(dataSet: Models.DataSet): void {
    const row = dataSet.rows[0];

    if (!this.settings.metrics || this.settings.metrics.length === 0) {
      throw new Error("No metrics defined");
    }

    this.settings.metrics.forEach(metric => {
      const metricIndex = dataSet.columns.findIndex(col => col.name === metric.name);
      const metricColumn = dataSet.columns[metricIndex];
      const metricLabel = metricColumn.displayName ?? metricColumn.name;
      const metricPreviousPeriodIndex = dataSet.columns.findIndex(col => col.name === metric.previousPeriod);
      const metricIndexPOP = dataSet.columns.findIndex(col => col.name === metric.pop);

      const subtitleOneValue = row[metricPreviousPeriodIndex]?.label ?? row[metricPreviousPeriodIndex]?.value;
      const subtitleOneLabel = "Prev. Period:";
      this.metrics.push({ "label": metricLabel, "value": row[metricIndex].label ?? row[metricIndex].value, "trend": dataSet.rows[0][metricIndexPOP]?.value as number, "subtitleOneValue": subtitleOneValue, "subtitleOneLabel": subtitleOneLabel });
    });

    this.title = this.settings.title;
    this.titleIconClasses = this.settings.titleIconClasses;
  }
}
